import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, unref as _unref, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4c3fa1bc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "msi-form" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("提交")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("重置")
const _hoisted_4 = { class: "msi-content" }
const _hoisted_5 = { class: "header" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode("批量导入工量具")
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" 批量打印选中选")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("批量删除选中项")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("导出")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("新增")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("编辑")
const _hoisted_12 = /*#__PURE__*/_createTextVNode("删除")
const _hoisted_13 = {
  class: "msi-content",
  style: {"margin-top":"0"}
}
const _hoisted_14 = { class: "header" }
const _hoisted_15 = /*#__PURE__*/_createTextVNode("新增工量具")
const _hoisted_16 = /*#__PURE__*/_createTextVNode("删除选中行")
const _hoisted_17 = { class: "dialog-footer" }
const _hoisted_18 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_19 = /*#__PURE__*/_createTextVNode("确认")
const _hoisted_20 = {
  class: "msi-form",
  style: {"padding-top":"0px"}
}
const _hoisted_21 = /*#__PURE__*/_createTextVNode("提交")
const _hoisted_22 = /*#__PURE__*/_createTextVNode("重置")
const _hoisted_23 = {
  class: "msi-content",
  style: {"padding-top":"0","margin-top":"0px"}
}
const _hoisted_24 = { class: "dialog-footer" }
const _hoisted_25 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_26 = /*#__PURE__*/_createTextVNode("确认")

import { getWareToolPage } from "@/service/main/gauge/essential";
import {
  getWareToolHousPage,
  addWareToolHous,
  editWareToolHous,
  deleteWareToolHous,
  detailWareToolHous
} from "@/service/main/gauge/putIn";
import Pagination from "@/components/Pagination/index.vue";
import MsiUpload from "@/common-ui/msi-upload/";
import { exportExcel } from "@/utils/exportExcel";
import { ElMessage, ElMessageBox } from "element-plus";
import { ref, nextTick } from "vue";
import { useStore } from "@/store";
import { formatUtcToData } from "@/utils/formate";
// 上传窗口

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const uploadVisible = ref(false);
//打开导入窗口
const openUploadDialog = () => {
  uploadVisible.value = true;
};
//关闭窗口
const closeUploadDialog = () => {
  getTabelData();
};

//store
const store = useStore();

// --------------------采购单列表-----------------------------------
//查询
const formModel = ref({
  code: "",
  name: "",
  CreatedUserName: "",
  CreatedTimeBegin: "",
  CreatedTimeEnd: "",
  CreateDate: [],
  PageNo: 1,
  PageSize: 10
});

//入库单列表数据
let tableData = ref([]);

//列表的数据条数
const totalItems = ref<number>(0);

//获取工量具列表
const getTabelData = () => {
  //判断创建时间是否有选择
  if (formModel.value.CreateDate.length > 0) {
    formModel.value.CreatedTimeBegin = formModel.value.CreateDate[0];
    formModel.value.CreatedTimeEnd = formModel.value.CreateDate[1];
  }
  getWareToolHousPage(formModel.value)
    .then((res) => {
      if (res.code == 200) {
        const { data } = res;
        const result = data;
        result.rows.map(
          (item: { hasChildren: boolean }) => (item.hasChildren = true)
        );
        tableData.value = result.rows;
        totalItems.value = result.totalRows;
      } else {
        ElMessage.error(`${res.code}:${JSON.stringify(res.message)}`);
      }
    })
    .catch((err) => {
      console.log(err);
      ElMessage.error(JSON.stringify(err));
    });
};
getTabelData();

//重置搜索
const resetForm = () => {
  formModel.value = {
    code: "",
    name: "",
    CreatedUserName: "",
    CreatedTimeBegin: "",
    CreatedTimeEnd: "",
    CreateDate: [],
    PageNo: 1,
    PageSize: 10
  };
  getTabelData();
};
// -----------------删除、导出操作--------------------------
//选中的行
const checkRows = ref<{ id: number }[]>([]);
// 选择
const handleSelectionChange = (val: any) => {
  checkRows.value = val;
};
const tableRef = ref();

//导出
const handExport = () => {
  let entozh = {
    id: "序号",
    code: "工量具编号",
    name: "工量具名称",
    specificationModel: "工量具规格",
    quantity: "入库数量",
    unit: "单位",
    createdUserName: "入库人",
    createdTime: "入库时间"
  };
  exportExcel(checkRows.value, entozh, "xlsx", "工量具入库信息表");
};
//批量删除
const handleBatchDelete = () => {
  const handleArr: number[] = [];
  checkRows.value.forEach((item) => {
    handleArr.push(item.id);
  });
  const obj = { id: handleArr };
  ElMessageBox.confirm("是否确认删除？", "提示", {
    confirmButtonText: "确认",
    cancelButtonText: "取消",
    type: "warning"
  })
    .then(() => {
      deleteWareToolHous(obj)
        .then((res: any) => {
          if (res?.code === 200) {
            ElMessage.success("删除成功");
            // 刷新列表
            getTabelData();
            tableRef.value.clearSelection();
          } else {
            ElMessage.error(`删除失败${res?.code}:${res.message}`);
          }
        })
        .catch((err: any) => {
          console.log(err);
          ElMessage.error(`删除失败${err}`);
        });
    })
    .catch(() => {
      ElMessage.info("已取消删除");
    });
};
//删除
const deleteUser = (code: number) => {
  const obj = { id: [code] };
  ElMessageBox.confirm("是否确认删除？", "提示", {
    confirmButtonText: "确认",
    cancelButtonText: "取消",
    type: "warning"
  })
    .then(() => {
      deleteWareToolHous(obj)
        .then((res: any) => {
          if (res?.code === 200) {
            ElMessage.success("删除成功");
            // 刷新列表
            getTabelData();
          } else {
            ElMessage.error(`删除失败${res?.code}:${res.message}`);
          }
        })
        .catch((err: any) => {
          console.log(err);
          ElMessage.error(`删除失败${err}`);
        });
    })
    .catch(() => {
      ElMessage.info("已取消删除");
    });
};
// -------------------获取采购单下物料详情-----------------------------------

//获取入库单下物料详情
const getDetail = (id: number) => {
  detailWareToolHous(id)
    .then((res) => {
      if (res.code == 200) {
        const { data } = res;
        const result = data;
        warehousOrderDetails.value.push(result);
      } else {
        ElMessage.error(
          JSON.stringify(
            `获取工量具详情失败${res.code}:${JSON.stringify(res.message)}`
          )
        );
      }
    })
    .catch((err) => ElMessage.error(JSON.stringify(err)));
};
// ----------------新增、编辑-------------------------------
//窗口类型
const dialogType = ref("add");

const dialogVisible = ref(false);

//添加编辑表单ref
const dialogRef = ref();
//添加/编辑参数
let addForm = ref({
  createdTime: "",
  updatedTime: "",
  createdUserName: "",
  createdUserId: "",
  code: "",
  quantity: 0,
  Details: []
});

//rules
const formRules = {
  // code: [{ required: true, message: "工量具编号不能为空", trigger: "blur" }]
};
//计算新增总数
const changeNum = () => {
  addForm.value.quantity = warehousOrderDetails.value.reduce((prev, next) => {
    return Number(prev) + Number(next.quantity ? next.quantity : 0);
  }, 0);
};
//打开新增、编辑窗口
const openDialog = (type: number, scope: any = {}) => {
  addForm.value.createdUserName = store.state.login.userInfo.name;
  addForm.value.createdTime = formatUtcToData(
    new Date().toString(),
    "YYYY-MM-DD hh:mm:ss"
  );
  if (type == 1) {
    dialogType.value = "add";
  } else {
    addForm.value.quantity = scope.quantity;
    dialogType.value = "edit";
    //获取物料
    getDetail(scope.id);
  }
  dialogVisible.value = true;
  //清除选中项
  nextTick(() => {
    dialogRef.value.clearValidate();
  });
};

//物料详情的table ref
const detailRef = ref();

//关闭窗口
const closeDialog = () => {
  addForm.value = {
    createdTime: "",
    updatedTime: "",
    createdUserName: "",
    createdUserId: "",
    code: "",
    quantity: 0,
    Details: []
  };
  warehousOrderDetails.value = [];
  checkedDetails.value = [];
  detailRef.value.clearSelection();
};

//添加编辑窗口物料列表
const warehousOrderDetails = ref<any[]>([]);

//物料详情列表选中的物料
const checkedDetails = ref<any[]>([]);

//物料详情列表中勾选事件
const detailsCheckChange = (val: any) => {
  checkedDetails.value = val;
};

//删除选中的物料详情
const delCheckedDetails = () => {
  ElMessageBox.confirm("是否确认删除？", "提示", {
    confirmButtonText: "确认",
    cancelButtonText: "取消",
    type: "warning"
  })
    .then(() => {
      checkedDetails.value.forEach((item) => {
        const index = warehousOrderDetails.value.findIndex(
          (detail) => detail.code == item.code
        );
        warehousOrderDetails.value.splice(index, 1);
        detailRef.value.clearSelection();
      });
    })
    .catch(() => ElMessage.info("已取消删除"));
};

//编辑、添加提交
const confirm = () => {
  addForm.value.createdUserId = store.state.login.userInfo.id;
  addForm.value.createdUserName = store.state.login.userInfo.name;
  addForm.value.createdTime = formatUtcToData(
    new Date().toString(),
    "YYYY-MM-DD hh:mm:ss"
  );
  addForm.value.updatedTime = formatUtcToData(
    new Date().toString(),
    "YYYY-MM-DD hh:mm:ss"
  );
  warehousOrderDetails.value.forEach((item) => {
    const obj = {
      createdUserId: store.state.login.userInfo.id,
      createdUserName: store.state.login.userInfo.name,
      createdTime: formatUtcToData(
        new Date().toString(),
        "YYYY-MM-DD hh:mm:ss"
      ),
      updatedTime: formatUtcToData(
        new Date().toString(),
        "YYYY-MM-DD hh:mm:ss"
      ),
      code: item.code,
      name: item.name,
      specificationModel: item.specificationModel,
      quantity: item.quantity,
      unit: item.unit,
      remark: item.remark,
      status: 0,
      id: item.id
    };
    addForm.value.Details.push(obj);
  });

  dialogRef.value.validate((vali: any) => {
    if (vali) {
      //添加
      if (dialogType.value == "add") {
        addWareToolHous(addForm.value.Details)
          .then((res) => {
            if (res.code == 200) {
              ElMessage.success("添加成功");
              getTabelData();
              dialogVisible.value = false;
            } else {
              addForm.value.Details = [];
              ElMessage.error(`${res.code}:${JSON.stringify(res.message)}`);
            }
          })
          .catch((err) => {
            addForm.value.Details = [];
            console.log(err);
          });
      } else {
        editWareToolHous(addForm.value.Details[0])
          .then((res) => {
            if (res.code == 200) {
              ElMessage.success("编辑成功");
              getTabelData();
              dialogVisible.value = false;
            } else {
              addForm.value.Details = [];
              ElMessage.error(`${res.code}:${JSON.stringify(res.message)}`);
            }
          })
          .catch((err) => {
            addForm.value.Details = [];
            console.log(err);
          });
      }
    } else {
      ElMessage.warning("表单验证失败");
    }
  });
};
// -----------------添加物料操作-------------------------
//工量具基础数据窗口
const addMaterialVisible = ref(false);

//工量具基础数据列表
const materialList = ref([]);

//工量具基础数据条数
const materialTotal = ref(0);

//工量具基础数据form
const materialForm = ref({
  code: "",
  name: "",
  PageNo: 1,
  PageSize: 10
});

//获取工量具基础列表
const getMaterialList = () => {
  getWareToolPage(materialForm.value)
    .then((res) => {
      if (res.code == 200) {
        const { data } = res;
        const result = data;
        materialList.value = result.rows;
        materialTotal.value = result.totalRows;
      } else {
        ElMessage.error(`${res.code}:${JSON.stringify(res.message)}`);
      }
    })
    .catch((err) => {
      console.log(err);
      ElMessage.error(JSON.stringify(err));
    });
};

//重置工量具
const resetMaterialForm = () => {
  materialForm.value = {
    code: "",
    name: "",
    PageNo: 1,
    PageSize: 10
  };
  getMaterialList();
};

//选中的工量具数据
const checkedMaterial = ref<any[]>([]);

//工量具基础数据勾选
const materialSelectionChange = (val: any) => {
  checkedMaterial.value = val;
};

//打开新增物料窗口
const addMaterialDialog = () => {
  getMaterialList();
  addMaterialVisible.value = true;
};

//工量具table的ref对象
const materialRef = ref();

//确认添加工量具
const confirmAddMaterial = () => {
  //工量具列表没数据，直接添加
  if (warehousOrderDetails.value.length == 0) {
    warehousOrderDetails.value.push(...checkedMaterial.value);
  } else {
    for (let i = 0; i < checkedMaterial.value.length; i++) {
      let idx = warehousOrderDetails.value.findIndex(
        (item: { code: any }) => item.code == checkedMaterial.value[i].code
      );
      if (idx > -1) {
        return ElMessage.warning(
          `工量具编号:${checkedMaterial.value[i].code}在工量具列表中已存在,请去除勾选`
        );
      }
    }
    warehousOrderDetails.value.push(...checkedMaterial.value);
  }

  addMaterialVisible.value = false;
};

//关闭新增工量具窗口
const closeMaterialDialog = () => {
  materialForm.value = {
    code: "",
    name: "",
    PageNo: 1,
    PageSize: 10
  };
  materialList.value = [];
  checkedMaterial.value = [];
  materialRef.value.clearSelection();
};

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_el_form, {
        model: formModel.value,
        "label-width": "120px"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, { span: 5 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, { label: "工量具编号:" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: formModel.value.code,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formModel.value.code) = $event)),
                        clearable: "",
                        placeholder: "请输入工量具编号"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 8 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, { label: "入库时间:" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_date_picker, {
                        modelValue: formModel.value.CreateDate,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formModel.value.CreateDate) = $event)),
                        type: "daterange",
                        "range-separator": "至",
                        "start-placeholder": "开始日期",
                        "end-placeholder": "结束日期",
                        "value-format": "YYYY-MM-DD",
                        style: {"width":"100%"}
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 6 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_button, {
                        type: "primary",
                        icon: "el-icon-search",
                        onClick: getTabelData
                      }, {
                        default: _withCtx(() => [
                          _hoisted_2
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_button, {
                        icon: "el-icon-refresh-right",
                        onClick: resetForm
                      }, {
                        default: _withCtx(() => [
                          _hoisted_3
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", null, [
          _createVNode(_component_el_button, {
            type: "info",
            icon: "el-icon-upload2",
            plain: "",
            onClick: openUploadDialog
          }, {
            default: _withCtx(() => [
              _hoisted_6
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "info",
            icon: "iconfont icon-biaoqianguanli",
            plain: "",
            disabled: checkRows.value.length == 0,
            onClick: _ctx.printTable
          }, {
            default: _withCtx(() => [
              _hoisted_7
            ]),
            _: 1
          }, 8, ["disabled", "onClick"]),
          _createVNode(_component_el_button, {
            type: "info",
            icon: "el-icon-delete",
            plain: "",
            disabled: checkRows.value.length == 0,
            onClick: handleBatchDelete
          }, {
            default: _withCtx(() => [
              _hoisted_8
            ]),
            _: 1
          }, 8, ["disabled"])
        ]),
        _createElementVNode("div", null, [
          _createVNode(_component_el_button, {
            type: "info",
            plain: "",
            icon: "el-icon-upload2",
            disabled: checkRows.value.length == 0,
            onClick: handExport
          }, {
            default: _withCtx(() => [
              _hoisted_9
            ]),
            _: 1
          }, 8, ["disabled"]),
          _createVNode(_component_el_button, {
            type: "primary",
            icon: "el-icon-plus",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (openDialog(1)))
          }, {
            default: _withCtx(() => [
              _hoisted_10
            ]),
            _: 1
          })
        ])
      ]),
      _createVNode(_component_el_table, {
        data: _unref(tableData),
        border: "",
        style: {"width":"100%"},
        "row-key": "id",
        ref_key: "tableRef",
        ref: tableRef,
        onSelectionChange: handleSelectionChange
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, {
            align: "center",
            width: "60",
            type: "selection",
            "reserve-selection": ""
          }),
          _createVNode(_component_el_table_column, {
            label: "序号",
            align: "center",
            width: "60",
            type: "index"
          }),
          _createVNode(_component_el_table_column, {
            label: "工量具编号",
            prop: "code",
            align: "center",
            "show-overflow-tooltip": ""
          }),
          _createVNode(_component_el_table_column, {
            label: "工量具名称",
            prop: "name",
            align: "center",
            "show-overflow-tooltip": ""
          }),
          _createVNode(_component_el_table_column, {
            label: "工量具规格",
            prop: "specificationModel",
            align: "center",
            "show-overflow-tooltip": ""
          }),
          _createVNode(_component_el_table_column, {
            label: "入库数量",
            prop: "quantity",
            align: "center",
            "show-overflow-tooltip": ""
          }),
          _createVNode(_component_el_table_column, {
            label: "单位",
            prop: "unit",
            align: "center",
            "show-overflow-tooltip": ""
          }),
          _createVNode(_component_el_table_column, {
            label: "入库人",
            prop: "createdUserName",
            align: "center",
            "show-overflow-tooltip": ""
          }),
          _createVNode(_component_el_table_column, {
            label: "入库日期",
            prop: "createdTime",
            sortable: "",
            width: "200",
            align: "center",
            "show-overflow-tooltip": ""
          }),
          _createVNode(_component_el_table_column, {
            label: "操作",
            width: "280px",
            align: "center"
          }, {
            default: _withCtx((scope) => [
              _createVNode(_component_el_button, {
                type: "info",
                plain: "",
                size: "small",
                icon: "el-icon-edit",
                disabled: scope.row.status == 1,
                onClick: ($event: any) => (openDialog(2, scope.row))
              }, {
                default: _withCtx(() => [
                  _hoisted_11
                ]),
                _: 2
              }, 1032, ["disabled", "onClick"]),
              _createVNode(_component_el_button, {
                type: "info",
                plain: "",
                size: "small",
                icon: "el-icon-delete",
                disabled: scope.row.status == 1,
                onClick: ($event: any) => (deleteUser(scope.row.id))
              }, {
                default: _withCtx(() => [
                  _hoisted_12
                ]),
                _: 2
              }, 1032, ["disabled", "onClick"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["data"]),
      _createVNode(Pagination, {
        total: totalItems.value,
        page: formModel.value.PageNo,
        "onUpdate:page": _cache[3] || (_cache[3] = ($event: any) => ((formModel.value.PageNo) = $event)),
        limit: formModel.value.PageSize,
        "onUpdate:limit": _cache[4] || (_cache[4] = ($event: any) => ((formModel.value.PageSize) = $event)),
        onPagination: getTabelData,
        style: {"margin-top":"20px","text-align":"center"}
      }, null, 8, ["total", "page", "limit"])
    ]),
    _createVNode(_component_el_dialog, {
      modelValue: dialogVisible.value,
      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((dialogVisible).value = $event)),
      title: dialogType.value == 'add' ? '新增工量具入库' : '编辑工量具入库',
      width: "65%",
      onClose: closeDialog
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_17, [
          _createVNode(_component_el_button, {
            onClick: _cache[8] || (_cache[8] = ($event: any) => (dialogVisible.value = false))
          }, {
            default: _withCtx(() => [
              _hoisted_18
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            disabled: warehousOrderDetails.value.length == 0,
            onClick: confirm
          }, {
            default: _withCtx(() => [
              _hoisted_19
            ]),
            _: 1
          }, 8, ["disabled"])
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          model: _unref(addForm),
          "label-width": "120px",
          ref_key: "dialogRef",
          ref: dialogRef,
          rules: formRules
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, { span: 10 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: "入库人:",
                      prop: "code"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _unref(addForm).createdUserName,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(addForm).createdUserName) = $event)),
                          disabled: "",
                          clearable: "",
                          placeholder: "请输入入库人"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 10 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: "入库日期:",
                      prop: "createdTime"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _unref(addForm).createdTime,
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(addForm).createdTime) = $event)),
                          disabled: "",
                          clearable: "",
                          placeholder: "请输入入库日期"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 10 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: "入库总数:",
                      prop: "quantity"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _unref(addForm).quantity,
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(addForm).quantity) = $event)),
                          disabled: "",
                          clearable: "",
                          placeholder: "请输入入库总数"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"]),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", null, [
              _createVNode(_component_el_button, {
                type: "primary",
                icon: "el-icon-plus",
                onClick: addMaterialDialog,
                disabled: dialogType.value == 'edit' ? true : false
              }, {
                default: _withCtx(() => [
                  _hoisted_15
                ]),
                _: 1
              }, 8, ["disabled"]),
              _createVNode(_component_el_button, {
                type: "info",
                icon: "el-icon-delete",
                plain: "",
                disabled: checkedDetails.value.length == 0,
                onClick: delCheckedDetails
              }, {
                default: _withCtx(() => [
                  _hoisted_16
                ]),
                _: 1
              }, 8, ["disabled"])
            ])
          ]),
          _createVNode(_component_el_table, {
            data: warehousOrderDetails.value,
            border: "",
            style: {"width":"100%"},
            "row-key": "id",
            ref_key: "detailRef",
            ref: detailRef,
            onSelectionChange: detailsCheckChange
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_table_column, {
                align: "center",
                width: "60",
                "reserve-selection": "",
                type: "selection"
              }),
              _createVNode(_component_el_table_column, {
                label: "序号",
                align: "center",
                width: "60",
                type: "index"
              }),
              _createVNode(_component_el_table_column, {
                label: "工量具编号",
                prop: "code",
                width: "150",
                align: "center",
                "show-overflow-tooltip": ""
              }),
              _createVNode(_component_el_table_column, {
                label: "工量具名称",
                prop: "name",
                align: "center",
                "show-overflow-tooltip": ""
              }),
              _createVNode(_component_el_table_column, {
                label: "工量具规格",
                prop: "name",
                align: "center",
                "show-overflow-tooltip": ""
              }),
              _createVNode(_component_el_table_column, {
                label: "备注",
                prop: "name",
                align: "center",
                "show-overflow-tooltip": ""
              }),
              _createVNode(_component_el_table_column, {
                label: "入库数量",
                align: "center",
                width: "155"
              }, {
                default: _withCtx((scope) => [
                  _createVNode(_component_el_input_number, {
                    modelValue: scope.row.quantity,
                    "onUpdate:modelValue": ($event: any) => ((scope.row.quantity) = $event),
                    onChange: ($event: any) => (changeNum(scope.row.quantity)),
                    min: 1,
                    size: "small"
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                label: "入库日期",
                align: "center",
                prop: "createdTime",
                width: "200"
              }),
              _createVNode(_component_el_table_column, {
                label: "入库人",
                align: "center",
                prop: "createdUserName",
                width: "150"
              })
            ]),
            _: 1
          }, 8, ["data"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "title"]),
    _createVNode(_component_el_dialog, {
      modelValue: addMaterialVisible.value,
      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((addMaterialVisible).value = $event)),
      title: "添加工量具详情",
      width: "60%",
      onClose: closeMaterialDialog
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_24, [
          _createVNode(_component_el_button, {
            onClick: _cache[14] || (_cache[14] = ($event: any) => (addMaterialVisible.value = false))
          }, {
            default: _withCtx(() => [
              _hoisted_25
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: confirmAddMaterial
          }, {
            default: _withCtx(() => [
              _hoisted_26
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_20, [
          _createVNode(_component_el_form, {
            model: materialForm.value,
            "label-width": "120px",
            size: "large"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_el_col, { span: 8 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_form_item, { label: "工量具编号:" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: materialForm.value.code,
                            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((materialForm.value.code) = $event)),
                            placeholder: "请输入工量具编号",
                            clearable: ""
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_col, { span: 8 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_form_item, { label: "工量具名称:" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: materialForm.value.name,
                            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((materialForm.value.name) = $event)),
                            placeholder: "请输入工量具名称",
                            clearable: ""
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_col, { span: 8 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_form_item, { "label-width": "20px" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_button, {
                            type: "primary",
                            icon: "el-icon-search",
                            onClick: getMaterialList
                          }, {
                            default: _withCtx(() => [
                              _hoisted_21
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_button, {
                            icon: "el-icon-refresh-right",
                            onClick: resetMaterialForm
                          }, {
                            default: _withCtx(() => [
                              _hoisted_22
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model"])
        ]),
        _createElementVNode("div", _hoisted_23, [
          _createVNode(_component_el_table, {
            data: materialList.value,
            border: "",
            style: {"width":"100%"},
            "row-key": "id",
            ref_key: "materialRef",
            ref: materialRef,
            onSelectionChange: materialSelectionChange
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_table_column, {
                align: "center",
                width: "60",
                "reserve-selection": "",
                type: "selection"
              }),
              _createVNode(_component_el_table_column, {
                label: "序号",
                align: "center",
                width: "60",
                type: "index"
              }),
              _createVNode(_component_el_table_column, {
                label: "工量具编号",
                prop: "code",
                align: "center",
                "show-overflow-tooltip": ""
              }),
              _createVNode(_component_el_table_column, {
                label: "工量具名称",
                prop: "name",
                align: "center",
                "show-overflow-tooltip": ""
              }),
              _createVNode(_component_el_table_column, {
                label: "工量具规格",
                prop: "specificationModel",
                align: "center",
                "show-overflow-tooltip": ""
              }),
              _createVNode(_component_el_table_column, {
                label: "备注",
                prop: "remark",
                align: "center",
                "show-overflow-tooltip": ""
              })
            ]),
            _: 1
          }, 8, ["data"]),
          _createVNode(Pagination, {
            total: materialTotal.value,
            page: materialForm.value.PageNo,
            "onUpdate:page": _cache[12] || (_cache[12] = ($event: any) => ((materialForm.value.PageNo) = $event)),
            limit: materialForm.value.PageSize,
            "onUpdate:limit": _cache[13] || (_cache[13] = ($event: any) => ((materialForm.value.PageSize) = $event)),
            onPagination: getMaterialList,
            style: {"margin-top":"20px","text-align":"center"}
          }, null, 8, ["total", "page", "limit"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: uploadVisible.value,
      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((uploadVisible).value = $event)),
      title: "工量具导入",
      width: "40%",
      onClose: closeUploadDialog
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(MsiUpload), { apiUrl: "/WareToolHous/import" })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})